export const screenBreakpoints = {
	TABLET: 1191,
	MOBILE: 768,
};
